(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-ls-home]').forEach((root) => {
      if (root.dataset.lsReady) return;
      root.dataset.lsReady = 'true';
      const mainGrid = root.querySelector('.ls-edit .ls-products');
      const filterTemplates = new Map([...root.querySelectorAll('template[data-ls-filter]')].map((template) => [template.dataset.lsFilter, template]));
      const catalogCards = [...root.querySelectorAll('.ls-product'), ...[...filterTemplates.values()].flatMap((template) => [...template.content.querySelectorAll('.ls-product')])];
      const cards = [...new Map(catalogCards.map((card) => [card.dataset.lsProduct, card])).values()];
      const dialog = root.querySelector('.ls-dialog');
      const content = root.querySelector('.ls-dialog-content');
      const empty = root.querySelector('.ls-empty');
      const filters = [...root.querySelectorAll('.ls-filters [data-filter]')];
      const results = root.querySelector('.ls-results');
      const labels = JSON.parse(root.querySelector('[data-ls-labels]').textContent);
      const carousels = [...root.querySelectorAll('.ls-edit, .ls-shelf')].map((section) => {
        const grid = section.querySelector('.ls-selection-carousel');
        const previous = section.querySelector('[data-ls-slide="previous"]');
        const next = section.querySelector('[data-ls-slide="next"]');
        if (!grid || !previous || !next) return null;
        const update = () => {
          const end = Math.max(0, grid.scrollWidth - grid.clientWidth);
          previous.disabled = grid.scrollLeft <= 1;
          next.disabled = grid.scrollLeft >= end - 1;
        };
        const scroll = (direction) => {
          const first = grid.querySelector('.ls-product');
          if (!first) return;
          const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
          const stride = first.getBoundingClientRect().width + gap;
          const perView = Math.max(1, Math.round((grid.clientWidth + gap) / stride));
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          grid.scrollBy({ left: direction * perView * stride, behavior: reduced ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => scroll(-1));
        next.addEventListener('click', () => scroll(1));
        grid.addEventListener('scroll', update, { passive: true });
        new ResizeObserver(update).observe(grid);
        return { update };
      }).filter(Boolean);
      const updateScrollControls = () => carousels.forEach((carousel) => carousel.update());
      let saved = new Set();
      try { saved = new Set(JSON.parse(localStorage.getItem('labelScoutSavedFinds') || '[]')); } catch {}
      const updateSaved = () => {
        root.querySelectorAll('[data-ls-save]').forEach((button) => {
          const active = saved.has(button.dataset.lsSave);
          button.setAttribute('aria-pressed', String(active));
          const title = button.closest('.ls-product').querySelector('.ls-product-name').textContent.trim();
          button.setAttribute('aria-label', `${active ? labels.removeSaved : labels.saveFind}: ${title}`);
        });
        root.querySelector('.ls-saved-count').textContent = saved.size;
        try { localStorage.setItem('labelScoutSavedFinds', JSON.stringify([...saved])); } catch {}
      };
      const showSaved = () => {
        content.replaceChildren();
        const heading = document.createElement('h2');
        heading.className = 'ls-dialog-title';
        heading.textContent = labels.savedTitle;
        content.append(heading);
        const selected = cards.filter((card) => saved.has(card.dataset.lsProduct));
        if (selected.length) {
          const grid = document.createElement('div');
          grid.className = 'ls-saved-grid';
          selected.forEach((card) => grid.append(card.cloneNode(true)));
          content.append(grid);
        } else {
          const p = document.createElement('p');
          p.className = 'ls-saved-empty';
          p.textContent = labels.savedEmpty;
          content.append(p);
        }
        updateSaved();
      };
      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-ls-save]');
        if (button) {
          saved.has(button.dataset.lsSave) ? saved.delete(button.dataset.lsSave) : saved.add(button.dataset.lsSave);
          updateSaved();
          if (dialog.open) showSaved();
        }
        const filter = event.target.closest('.ls-filters [data-filter]');
        if (filter) {
          const template = filterTemplates.get(filter.dataset.filter);
          if (!template) return;
          mainGrid.replaceChildren(template.content.cloneNode(true));
          mainGrid.scrollLeft = 0;
          requestAnimationFrame(updateScrollControls);
          const visible = mainGrid.querySelectorAll('.ls-product').length;
          filters.forEach((item) => item.setAttribute('aria-pressed', String(item === filter)));
          results.textContent = `${String(visible).padStart(2, '0')} ${labels.selectedFinds}`;
          empty.hidden = visible > 0;
          updateSaved();
        }
        if (event.target.closest('.ls-mobile-nav a')) {
          root.querySelector('.ls-mobile-nav').hidden = true;
          root.querySelector('.ls-mobile-menu').setAttribute('aria-expanded', 'false');
        }
      });
      root.querySelector('.ls-saved-toggle').addEventListener('click', () => { showSaved(); dialog.showModal(); });
      root.querySelector('.ls-dialog-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }
      });
      const searchPanel = root.querySelector('.ls-search-panel');
      root.querySelector('.ls-search-toggle').addEventListener('click', () => {
        searchPanel.hidden = !searchPanel.hidden;
        root.querySelector('.ls-search-toggle').setAttribute('aria-expanded', String(!searchPanel.hidden));
        if (!searchPanel.hidden) searchPanel.querySelector('input[type=search]').focus();
      });
      root.querySelector('.ls-search-close').addEventListener('click', () => { searchPanel.hidden = true; root.querySelector('.ls-search-toggle').focus(); });
      root.querySelector('.ls-mobile-menu').addEventListener('click', (event) => {
        const menu = root.querySelector('.ls-mobile-nav');
        menu.hidden = !menu.hidden;
        event.currentTarget.setAttribute('aria-expanded', String(!menu.hidden));
      });
      root.querySelector('.ls-marquee-toggle').addEventListener('click', (event) => {
        const paused = root.querySelector('.ls-brandline').classList.toggle('is-paused');
        event.currentTarget.setAttribute('aria-pressed', String(paused));
        event.currentTarget.textContent = paused ? labels.play : labels.pause;
        event.currentTarget.setAttribute('aria-label', paused ? labels.playAnimation : labels.pauseAnimation);
      });
      root.querySelector('[data-ls-country]')?.addEventListener('change', (event) => event.target.form.submit());
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !searchPanel.hidden) { searchPanel.hidden = true; root.querySelector('.ls-search-toggle').focus(); }
      });
      updateSaved();
      updateScrollControls();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
